<app-popover *ngIf="singleRequestDetails" (closeCallback)="handleCloseRequestDetails()" size="full">
  <div popover-header>
    <div class="booking-details-header">
      Request ID {{singleRequestDetails[0].requestId}}
    </div>
  </div>
  <div popover-content>
    <app-requester-details [requester]="singleRequestDetails[0].requester" [paymentType]="singleRequestDetails[0].paymentType"></app-requester-details>
    <app-payee-details *ngIf = "singleRequestDetails[0].payer" [payee]="singleRequestDetails[0].payer" [paymentType]="singleRequestDetails[0].paymentType"></app-payee-details>
    <div *ngFor="let booking of singleRequestDetails">
      <app-booking-details [booking]="booking" showBookingId=true></app-booking-details>
    </div>
  </div>
</app-popover>